import { Component, OnInit } from '@angular/core';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  //updateDate = new Date().toJSON("yyyy/MM/dd HH:mm");
  updateDate = new Date().toJSON("yyyy");
  constructor() { }

  ngOnInit(): void {
  }
  navToProd(){
    let a = document.createElement('a'); 
     a.href ='https://aayurway.myshopify.com/collections/capsules'
     a.target= '_blank';
     a.click();
  }
}
